import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

import { ICookie } from '../../common/interfaces/index.interface';
  import CookieCategory from './CookieCategory.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'PreferencesSection',
  props: {
    cookies: null,
    visible: { type: Boolean }
  },
  setup(__props: any) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ccn-preferences", { 'ccn-preferences--open': __props.visible }])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.cookies, (cookieCategory) => {
      return (_openBlock(), _createBlock(CookieCategory, {
        key: cookieCategory.name,
        active: cookieCategory.active,
        cookies: cookieCategory.cookies,
        disabled: cookieCategory.name === `necessary`,
        explanation: cookieCategory.explanation,
        headline: cookieCategory.title,
        indeterminate: cookieCategory.indeterminate,
        name: cookieCategory.name,
        "onUpdate:active": ($event: any) => (_ctx.$emit(`update:category-active`, { active: $event, cookies: cookieCategory })),
        "onUpdate:activeSingleCookie": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit(`update:active-single-cookie`, $event)))
      }, null, 8, ["active", "cookies", "disabled", "explanation", "headline", "indeterminate", "name", "onUpdate:active"]))
    }), 128))
  ], 2))
}
}

})